import { STICKY_GESTORES_IDS } from "../constants/permisos";
import { client } from "./supabase";

// ─── Sticky en el panel Futuros de FlujoCajaV2 ─────────────────────────────────
//
// Fijar filas de "Futuros" arriba de todo, con el saldo acumulado descontándolas primero
// (docs/modulos/flujo-caja-v2.md § Sticky en Futuros). Capa de presentación (10.244): la
// tabla `flujo_caja_sticky` solo guarda QUÉ entry_id está fijado y en qué orden — la fila
// sigue siendo la misma entry de siempre (fecha, color, kebab, vinculación).
//
// Quién ve / quién actúa (10.279): TODOS los autenticados ven las sticky (RLS SELECT abierto);
// fijar/soltar (INSERT/DELETE) es Ignacio (Chile=1, Perú=4) + Franco Díaz (id 9, administrativo
// CHI, 2026-10-08) — por ID ESTABLE de usuario (10.219 — nunca por rol/nombre). El sticky es
// UNO SOLO y compartido entre ambos (no hay sticky "de Ignacio" vs "de Franco").
//
// `STICKY_GESTORES_IDS` vive en permisos.js, puerta DEDICADA (no se reusa `ER_V2_IDS` ni
// `LIQUIDACIONES_ADMIN_IDS` aunque hoy coincidan en número [1,4,9] — acoplar el gate de sticky
// a un permiso de otra feature haría que un cambio ahí mueva el sticky sin que nadie lo note;
// corrección explícita de Ignacio tras un primer intento que sí reusaba `ER_V2_IDS`).
export const puedeGestionarSticky = (userId) => STICKY_GESTORES_IDS.includes(userId);

// Lee las sticky de un país, en orden de fijado (columna `orden` ascendente).
export const getStickyFuturos = async (pais) => {
  const { data, error } = await client
    .from("flujo_caja_sticky")
    .select("*")
    .eq("pais", pais)
    .order("orden", { ascending: true });
  if (error) throw error;
  return data || [];
};

// Fija una entry. `ordenMax` es el `orden` más alto YA fijado en ese país (0 si no hay
// ninguna) — el caller lo calcula desde el state local (10.234, sin query extra por fijado).
export const fijarEntrySticky = async (pais, entryId, ordenMax, userId) => {
  const { data, error } = await client
    .from("flujo_caja_sticky")
    .insert({ pais, entry_id: String(entryId), orden: ordenMax + 1, creado_por: userId })
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Suelta una entry fijada.
export const soltarEntrySticky = async (pais, entryId) => {
  const { error } = await client.from("flujo_caja_sticky").delete().eq("pais", pais).eq("entry_id", String(entryId));
  if (error) throw error;
};

// "Soltar todas" del header (Fase 2) — vacía sin confirmación, solo del país activo.
export const soltarTodasSticky = async (pais) => {
  const { error } = await client.from("flujo_caja_sticky").delete().eq("pais", pais);
  if (error) throw error;
};
